import { useContext } from 'react';
import { Box, Theme, useTheme } from '@mui/material';
import { ReactComponent as EmissionFactorIcon } from '../../assets/icons/Carbon Emissions.svg';
import ConfigurationWrapper from '../../components/shared/ConfigurationWrapper';
import PanelEmissionFactors from '../../components/configuration/emission_factors/PanelEmissionFactors';
import { useModuleDurationTracking } from '../../hooks/useModuleDurationTracking';
import { GroupContext } from '../../context/GroupContext';
import { CompanyContext } from '../../context/CompanyContext';

const ConfigurationEmissionFactors = () => {
  const { group } = useContext(GroupContext);
  const { company } = useContext(CompanyContext);

  // Track module duration.
  useModuleDurationTracking(
    'Configuration',
    'Emission Factors',
    group?.id,
    company?.id,
    !group || !company
  );

  const theme: Theme = useTheme();
  const primary_blue: string = theme.palette.primary.main;

  if (!group || !company) return null;

  return (
    <Box>
      <ConfigurationWrapper
        title="Emission Factors"
        icon={<EmissionFactorIcon height={50} fill={primary_blue} stroke={primary_blue} />}
        previous={null}
        next={null}
      >
        <PanelEmissionFactors />
      </ConfigurationWrapper>
    </Box>
  );
};

export default ConfigurationEmissionFactors;
